var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx_blankBox"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.paramsUrl)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }